import { WmLineChart } from "@watermarkinsights/ripple-react";
import { AiDataCaptureCaption } from "../AiDataCaptureCaption";
import type { LineChartPayload } from "../ai-chat-message-utils";

interface AiLineChartProps {
  payload: LineChartPayload;
}

export const AiLineChart = ({ payload }: AiLineChartProps) => {
  const {
    label,
    xAxisLabel,
    yAxisLabel,
    units,
    showGrid,
    visibilityToggles,
    showDeltas,
    data,
  } = payload;

  const lineDataGroupedBySeriesAndXValue = data.reduce<
    Record<string, Record<string, number | null>>
  >((accumulator, series) => {
    accumulator[series.label] = series.data.reduce<
      Record<string, number | null>
    >((pointsByXValue, point) => {
      pointsByXValue[point.x] = point.y;
      return pointsByXValue;
    }, {});
    return accumulator;
  }, {});

  // Stable key ensures WmLineChart remounts when data changes
  const stableChartKey = data
    .map(
      (series) =>
        `${series.label}:${series.data.map((p) => `${p.x}=${p.y}`).join(",")}`,
    )
    .join("|");

  return (
    <div className="tcw-chart-card">
      {label && <p className="tcw-chart-label">{label}</p>}
      <div className="tcw-chart-wrapper tcw-chart-wrapper--line">
        <WmLineChart
          key={stableChartKey}
          label={label ?? "Line Chart"}
          lineData={lineDataGroupedBySeriesAndXValue}
          xAxisLabel={xAxisLabel ?? ""}
          yAxisLabel={yAxisLabel ?? ""}
          units={units ?? ""}
          showGrid={showGrid ?? true}
          visibilityToggles={visibilityToggles ?? data.length > 1}
          showDeltas={showDeltas ?? false}
        />
      </div>
      <AiDataCaptureCaption />
    </div>
  );
};
